<template>
  <div class="animated fadeIn invoices--invoices-list">
    <fixed-header title="Invoices" :records="pageInfo.totalItems" hideBackBtn hideNewOfferBtn>
      <!-- <add-invoice v-if="checkClaim(CAN_ADD_INVOICES)"/> -->
    </fixed-header>

    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-start align-items-end mb-2">
          <b-form-group label="Status" class="mr-2">
            <b-form-select v-model="filterObj.statusId" @change="onSearch">
              <option :value="null">All</option>
              <option v-for="option in sortSelect(statusOptions)" :key="option.name" :value="option.id">
                {{option.name}}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label="Invoice #" class="mr-2">
            <b-form-input v-model="filterObj.invoiceNumber" @input="onSearch" size="sm"/>
          </b-form-group>
          <b-form-group label="Sales Order #" class="mr-2">
            <b-form-input v-model="filterObj.soNumber" @input="onSearch" size="sm"/>
          </b-form-group>
          <b-form-group label="Company" class="mr-2">
            <b-form-input v-model="filterObj.companyName" @input="onSearch" size="sm"/>
          </b-form-group>
          <b-form-group label="Needs auth" class="mr-2" style="margin-bottom: 5px;">
            <b-form-checkbox v-model="filterObj.needsAuthorization"
                             :indeterminate.sync="filterObj.needsAuthorization == null" @input="onSearch"/>
          </b-form-group>
          <b-form-group label="Sales Rep" class="mr-2">
            <!-- <b-form-input v-model="filterObj.salesRep"  @input="onSearch" size="sm" /> -->
            <b-form-select v-model="filterObj.salesPersonUserId" @change="onSearch">
              <option :value="null">All</option>
              <option
                v-for="(selectRep, indexRep) in sortSelect(salesReps)"
                :key="indexRep"
                :value="selectRep.id"
              >{{ selectRep.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <date-range-picker ref="dateRangePicker" :handleSearch="onSearch"></date-range-picker>
          <b-button class="mr-2" size="sm" @click="onClear">Clear</b-button>
        </div>
        <grid-component
          isResizable
          isReorderable
          isSortable
          :canEdit="checkClaim(CAN_EDIT_INVOICES)"
          :canDelete="checkClaim(CAN_DELETE_INVOICES)"
          :gridId="gridId"
          :pageable="pageable"
          :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
          :take="pageInfo.pageSize"
          :itemData="itemData"
          :pageSizes="pageInfo.pageSize"
          :totalItems="pageInfo.totalItems"
          :fields="fields"
          :sortBy="pageInfo.sortBy"
          :sortOrder="pageInfo.sortOrder"
          :sortMethod="sortGrid"
          :onEdit="pushToDetails"
          :onDelete="onDelete"
          :handleRowClick="onRowClick"
          :styleCustom="'height: 335px'"
          @getData="onGetData"
          :isTblLoader="tblLoader"
        />
      </div>
    </div>
    <b-card>
      <b-tabs>
        <b-tab>
          <template v-slot:title>
            Invoice Items &nbsp;<b-badge variant="primary">{{ invoiceLines.length }}</b-badge>
          </template>
          <invoice-lines :invoiceId="selectedRowItemId"
                         @showEdit="onShowEdit"
                         @showDelete="onDeleteInvoiceLine"
                         @selectedInvoiceLine="setInvoiceLine"/>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- Part Modal -->
    <div id="add-part-popup" class="d-inline pull-left">
      <b-modal id="add-part-modal" ref="add-part-modal" size="xl"
               scrollable>
        <template slot="modal-header">
          <h5 class="modal-title">Edit Line Detail</h5>
        </template>

        <!-- <part-form @newPart="addPart" @partChange="chgPartId" /> -->
        <line-details
          ref="editLineDetails"
          :lineObj="invoiceLine"
          @lineChange="onLineChange"
          invoiceView
          invoiceLineView
          priceOnly
          showMaxQty
          @line-validation="isLineInvalid = $event"
        />

        <template slot="modal-footer">
          <b-button @click="handleCancel">Cancel</b-button>
          <b-button v-if="checkClaim(CAN_EDIT_INVOICES)" class="mr-2" variant="primary" @click="savePartForm" :disabled="isSavingLine">
            <i v-if="isSavingLine" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>          
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
  import { debounce, unionBy } from 'lodash';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import LineDetails from '@/shared/components/LineDetails/index';
  import InvoiceLines from '@/pages/Invoices/components/InvoiceLines';
  import {
    INVOICE_STATUS,
    GRID_PAGE_SIZES,
    GRID_ID,
    SEARCH_DEBOUNCE_TIME,
  } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import AddInvoice from './components/add';
  import gridFields from './fields';
  import DateRangePicker from '@/shared/components/DateRangePicker';

  export default {
    components: {
      FixedHeader,
      InvoiceLines,
      GridSettings,
      DateRangePicker,
      AddInvoice,
      GridComponent,
      LineDetails,
    },
    metaInfo: () => ({
      title: 'Invoices',
    }),
    data() {
      return {
        fields: gridFields,
        gridId: GRID_ID.INVOICES,
        pageable: {
          pageSizes: GRID_PAGE_SIZES,
        },
        selectedRowItemId: 0,
        // statusOptions: [
        //   { id: 138, name: 'New' },
        //   { id: 139, name: 'Sent' },
        //   { id: 140, name: 'Paid' },
        // ],
        statusOptions: INVOICE_STATUS,
        mergedObj: {},
        invoiceLine: {},
        filterPageName: 'invoiceListPage',
        isSavingLine: false,
        isLineInvalid: false
      };
    },
    computed: {
      ...mapState('invoices', [
        'lastOpenedId',
        'pageInfo',
      ]),
      ...mapState('invoiceLines', ['invoiceLines']),
      ...mapState('salesReps', ['salesReps']),
      ...mapGetters('invoices', [
        'invoices',
        'selectedItemId',
        'filters',
        'tblLoader',
      ]),
      ...mapGetters('account', ['gridSettingsById']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        if (this.invoices == undefined || !this.invoices.length) return [];
        return this.invoices.map((invoice) => ({ ...invoice, selected: invoice.id === this.selectedRowItemId }));
      },
      filterObj() {
        return this.filters[this.filterPageName] || {}
      }
    },
    methods: {
      ...mapMutations('invoices', {invoiceSetItem:'setItem'}),
      ...mapActions('invoices', ['getAll', 'sortGrid', 'remove', 'search', 'deleteInvoice']),
      ...mapActions('account', ['saveGridSettings']),
      ...mapActions('salesReps', ['getSalesReps']),
      ...mapActions('invoiceLines', [
        'getInvoiceLines',
        'updateInvoiceLine',
        'deleteInvoiceLine',
      ]),
      async onGetData(params) {
        await this.getAll(params);
      },
      onSearch: debounce(function() {
        this.filterObj.isProforma = false;
        this.search({'filters':this.filterObj,page:this.filterPageName});
      }, SEARCH_DEBOUNCE_TIME),
      onClear(callSearch = true) {
        /*Object.keys(this.filterObj).forEach(filterName => {
          this.filterObj[filterName] = null;
        });*/
        this.clearObject(this.filterObj);
        this.filterObj.isProforma = false;
        if (callSearch) {
          this.search({'filters':this.filterObj,page:this.filterPageName});
        }
      },
      onRowClick(row) {
        this.selectedRowItemId = row.dataItem.id;
        // const { id, detailsVisible } = row.dataItem;
        // this.select({ id, isChecked: !detailsVisible });
      },
      pushToDetails(row) {
        /*this.setLastOpenedId(row.id);*/
        this.invoiceSetItem({ resource: 'lastOpenedId', payload: row.id });

        this.$router.push({
          name: 'invoices.edit',
          params: { id: row.id },
        });
      },
      async onDelete({ id }) {
        this.selectedRowItemId = id;
        const deleteConfirmed = await this.openConfirmBox({ message: `Are you sure you want to delete invoice?  This action cannot be undone.` });
        if (deleteConfirmed) {
          const response = await this.deleteInvoice(id);

          if (response != undefined && response.status == 200) {
            this.selectedRowItemId = (this.selectedRowItemId == id) ? 0 : this.selectedRowItemId;
            this.getAll({});
          }
          
        }
      },
      onLineChange(lineObj) {
        this.mergedObj = {
          ...this.mergedObj,
          ...lineObj,
        };
      },
      onShowEdit(invoiceLine) {
        this.invoiceLine = invoiceLine;

        this.$refs['add-part-modal'].show();
      },
      async onDeleteInvoiceLine(line) {
        // console.log(lineId, "Line")
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete this Invoice Line Id: ${line.id}?`});
        if (deleteConfirmed) {
          await this.deleteInvoiceLine({
            id: line.invoiceId,
            lineId: line.id,
          });

          // this.$snotify.success('Invoice Line Deleted Successfully', 'Invoice Line');
          // await this.getInvoiceLines(this.selectedRowItemId);
        }
      },
      setInvoiceLine(invoiceLine) {
        this.invoiceLine = invoiceLine;
      },
      async savePartForm() {
        await this.$refs.editLineDetails.getLineValidation();
        if (!this.isLineInvalid) {
          this.isSavingLine = true;
          this.mergedObj = {
            ...this.mergedObj,
            invoiceId: this.selectedRowItemId,
            id: this.invoiceLine.id,
          };
          await this.updateInvoiceLine(this.mergedObj);
          this.isSavingLine = false;
          this.$$bvModal.hide('add-part-popup');
          this.$snotify.success('Invoice Line Updated Successfully', 'Invoice Line');
          await this.getInvoiceLines(this.selectedRowItemId);
        }
        
      },
      handleCancel() {
        this.$bvModal.hide('add-part-popup');
      },
    },
    watch: {
      async invoices() {
        this.selectedRowItemId = await this.setSelectedRowId(this.invoices,this.selectedRowItemId,this.lastOpenedId);
        /*//This function sets the first row as the selected row
        if (this.invoices && this.invoices.length > 0 && this.selectedRowItemId === 0 && !this.lastOpenedId) {
          this.selectedRowItemId = this.invoices[0].id;
          const { id, detailsVisible } = this.invoices[0];
          this.select({ id, isChecked: !detailsVisible });
        }*/
      },
    },
    async mounted() {
      if ('clear' in this.$route.query) {
        this.pageInfo.pageNumber = 1;
        this.onClear(false);
        this.clearRoute();
      } else {

        if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter){
          this.clearObject(this.filterObj);
          this.filterObj.isProforma = false;
        }

        if('needsAuthorization' in this.$route.params && this.$route.params.needsAuthorization) {
          this.filterObj.needsAuthorization = true;
          delete this.$route.params.needsAuthorization;
        }

        if('invoiceStatus' in this.$route.params) {
          this.filterObj.statusId = this.$route.params.invoiceStatus;
          delete this.$route.params.invoiceStatus;
        }

        if('salesPersonFilter' in this.$route.params && this.$route.params.salesPersonFilter) {
          this.filterObj.salesPersonUserId = this.$route.params.salesPersonFilter;
          delete this.$route.params.salesPersonFilter;
        }

        if('companyName' in this.$route.params) {
          this.filterObj.companyName = this.$route.params.companyName;
          delete this.$route.params.companyName;
        }

        if (this.lastOpenedId) {
          this.selectedRowItemId = this.lastOpenedId;
        }

        this.invoiceSetItem({resource: 'filterPage', payload: this.filterPageName});

        if('statisticFilter' in this.$route.params && this.$route.params.statisticFilter) {
          this.search({'filters':this.filterObj,page:this.filterPageName});
          delete this.$route.params.statisticFilter;
        }else {
          this.invoiceSetItem({
            resource: 'pageInfo',
            payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize}
          });
          await this.getAll({});
        }
        this.getSalesReps();
      }

    },
    beforeDestroy() {
      /*this.select({ id: null, isChecked: false });*/
    },
  };
</script>